module.exports = __webpack_public_path__ + "static/media/angle-up.b0817084.svg";